import { FREIGHT_URL } from '@/constants';
import { UnauthorizedError, UnexpectedError } from '@/services';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';

import { FreightResponseBody } from './types';

export const getFreightService = async (freightId: string): Promise<FreightResponseBody> => {
  const uri = fromRiskBff(FREIGHT_URL).replace('{freightId}', freightId);
  const { body, status } = await httpClient.get<FreightResponseBody>(uri);

  switch (status) {
    case HttpStatusCode.ok:
      return body;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      throw new UnexpectedError();
  }
};
